import React from 'react'

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    small: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-[3px]',
    medium: 'h-8 w-8 border-[3px]',
    lg: 'h-12 w-12 border-[3px]',
    large: 'h-12 w-12 border-[3px]',
  }

  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div
        className={`animate-spin rounded-full
                    border-surface-200 border-t-primary-500
                    ${sizeClasses[size]}`}
        role="status"
        aria-label="Loading"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  )
}

export default LoadingSpinner
